import React from 'react';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'elevated' | 'outline';
}
export function Card({
  children,
  className = '',
  variant = 'default',
  ...props
}: CardProps) {
  const variants = {
    default: 'bg-white border border-slate-100',
    elevated: 'bg-white shadow-xl shadow-slate-200/50 border-0',
    outline: 'bg-transparent border-2 border-slate-200'
  };
  return <div className={`rounded-xl overflow-hidden ${variants[variant]} ${className}`} {...props} data-id="element-183">
      {children}
    </div>;
}